
export class StorePackingKeyRecoveryInformationRequest {
    public encryptionKey: string;
    public encryptedPrivateKey: string;
}
